/** @jsx jsx */
import { css, jsx } from "@emotion/core"

import React from "react"

export function ButtonsWrapper({
  children,
  className,
  gap = 6,
}: {
  children: React.ReactNode
  className?: string
  gap?: number
}) {
  return (
    <div
      css={css`
        flex-basis: max-content;
        display: flex;
        flex-wrap: wrap;
        gap: ${gap}px;
      `}
      className={className}
    >
      {children}
    </div>
  )
}
